module.exports = __webpack_public_path__ + "img/roulette-card-spade.fd88a45c.svg";